//Include Constant Contact inline snippet to initialize hidden email form that signs event registrants up for emails
var _ctct_m = "49e1ce933c8cb01a581333911cab9156";
(function() {
  var ccScript = document.createElement("script");
  ccScript.id = "signupScript";
  ccScript.setAttribute(
    "src",
    "//static.ctctcdn.com/js/signup-form-widget/current/signup-form-widget.min.js"
  );
  ccScript.setAttribute("async", "async");
  ccScript.setAttribute("defer", "defer");
  document.documentElement.appendChild(ccScript);
})();

(function($) {
  const page_title = document.title.split(" | ")[0];
  const event_date = document.querySelector(
    ".post-event#content .post__meta .post__date"
  );
  const $email_field = $(".em-booking-form-details #user_email");

  const $booking_form = $(".em-booking-form");
  const $booking_form_submit = $booking_form.find(".em-booking-submit");
  const $booking_form_email_optin = $booking_form.find("#cc_newsletter_signup");
  //const event_registration_type is defined globally in the Twig template from the Events Manager post metadata (post.custom._event_location_type)
  //const stws_2021_campaigns.post_topic is defined globally in the Twig template from the Events Manager post metadata (post.tags)

  window.dataLayer = window.dataLayer || [];

  initFormEvent = () => {
    return {
      form_type: 'webinar_registration',
      topic: window.stws_2021_campaigns ? stws_2021_campaigns.post_topic : '',
      date_of_webinar: event_date.innerText.replace(/\s/g, " "),
      webinar_title: page_title.split(" - ")[0],
      user_id: btoa($email_field.val()), 
      email_optin: $booking_form_email_optin.is(':checked')
    }
  }

  //Log AJAX errors and submit an event to the GA dataLayer
  handleAJAXError = req => {
    console.error(`Form error`);
    console.error(req);

    event = {
      ...initFormEvent(),
      ...{
        event: 'error',
        message: "The registration attempt ended in an error.",
        status: req.status,
        response: req.responseJSON ? req.responseJSON.errors : req.statusText
      }
    }

    //console.log(event);
    window.dataLayer.push(event);
  };

  //Log form actions and submit an event to the GA dataLayer
  handleFormAction = (action, msg) => {
    //console.log(`Form action: ${msg}`);

    event = {
      ...initFormEvent(),
      ...{
        event: action,
        message: msg
      }
    }

    //console.log(event);
    window.dataLayer.push(event);
  };

  const handleEventFormResponse = (e, req, opts) => {
    //Intercept AJAX requests
    if (opts.url.indexOf("admin-ajax.php") !== -1) {
      const data = new URLSearchParams(opts.data);
      //This is a booking event
      if (data.get("action") === "booking_add") {

        //Fire once per successful submit
        $(document).off('ajaxComplete', handleEventFormResponse);

        //The request was successful
        if (req && req.status == 200) {
          res = req.responseJSON;
          //Booking was successful
          if (res.result) {
            //console.log("The registration attempt completed successfully.");
            handleFormAction(
              "generate_lead",
              "User successfully completed a registration."
            );
          } else {
            handleAJAXError(req);
          }
        } else {
          handleAJAXError(req);
        }
      }
    }
  }

  //Track clicks on the booking form register button
  $booking_form_submit.on("click", () => {
    handleFormAction("form_click", "User clicked the registration button.");
  });

  //Track booking form submissions
  $booking_form.on("submit", () => {
    handleFormAction("form_submit", "User submitted the registration form.");

    $(document).on('ajaxComplete',handleEventFormResponse);

    //Logic for syncing event registrations and email signups on event pages
    const $email_form = $(".register__form .ctct-form-custom");
    const $email_flag = $booking_form.find("#cc_newsletter_signup");
    const $booking_email = $booking_form.find("#user_email");
    const $email_email = $email_form.find("#email_address_1");
    if ($email_flag.prop("checked")) {
      $email_email.val($booking_email.val());
      $email_form.submit();
    } else {
      $email_email.val(null);
    }
  });

  //Auto-opt-in privacy prompt
  $('.input-field-data_privacy_consent input[type="checkbox"]').prop(
    "checked",
    true
  );

  //Jump-link to registration form
  $registerEl = $(".register__register");
  $registerElOffset = $registerEl.offset().top - 100;
  $registerInput = $registerEl
    .find("form input:not([type='hidden']), form select")
    .first();

  $(".post__actions .link-jump").on("click", () => {
    $("html,body").animate(
      {
        scrollTop: $registerElOffset
      },
      1000,
      () => {
        $registerInput.focus();
      }
    );
  });

})(jQuery);
